// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__-5xka","col":"styles_col__1B-uO"};